




























import { Vue, Component, Prop } from 'vue-property-decorator'
import GoogleMapDialog from '../../components/GoogleMapDialog'
import { capitalSpacing, upperCase } from '@/utils'
@Component({
  components: {
    GoogleMapDialog
  },
  filters: {
    upperCase,
    capitalSpacing
  }
})
export default class HomeShopItem extends Vue {
  @Prop({ type: String, required: true }) name!: string
  @Prop({ type: String, required: true }) address1!: string
  @Prop({ type: String, required: true }) address2!: string
  @Prop({ type: String, required: true }) country!: string
  @Prop({ type: Number, required: true }) latitude!: number
  @Prop({ type: Number, required: true }) longitude!: number

  enlargedMap: boolean = false

  /* Methods */
  onItemClicked() {
    this.enlargedMap = true
  }
}
